import { scrollTo } from '../helper-functions/scrollTo';

export const initScrollToAnchor = () => {
    // VARS
    const links = document.querySelectorAll('[data-anchor-link]');
    if (!links.length) return;

    // LISTENERS
    links.forEach((link) => {
        link.addEventListener('click', handleOnClickLink, false);
    });

    // HANDLERS
    function handleOnClickLink(event) {
        event.preventDefault();
        scrollTo(this.getAttribute('href'), true, -150);
    }
};
